module.exports = __webpack_public_path__ + "c40af4c71d7315ce5a05324cf61dcedc.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201605_uj.jpg
// module id = 646
// module chunks = 0